import { IReducerAction } from 'models/context';
import { IGlobalProperty } from 'models/globalProperty';
import { EActionTypes } from 'state/actions/globalProperty';

interface IState {
  shortDateFormat: string;
  midDateFormat: string;
  longDateFormat: string;
  currency: string;
  unit: string;
}

export const initialState: IState = {
  shortDateFormat: 'dd/MM/yyyy',
  midDateFormat: 'dd/MM/yyyy HH:mm',
  longDateFormat: 'dd/MM/yyyy HH:mm:ss',
  currency: 'GBP',
  unit: 'cm',
};

export const reducer = (state: IState, { type, payload }: IReducerAction) => {
  switch (type) {
    case EActionTypes.GET_DATE_FORMAT: {
      const dateFormat = payload.find(
        (prop: IGlobalProperty) => prop.key === 'date_format',
      )?.value;
      const currency = payload.find(
        (prop: IGlobalProperty) => prop.key === 'currency',
      )?.dictionaryValue;
      const unit = payload.find(
        (prop: IGlobalProperty) => prop.key === 'measurement_unit',
      )?.dictionaryValue;

      return {
        ...state,
        shortDateFormat: dateFormat,
        midDateFormat: `${dateFormat} HH:mm`,
        longDateFormat: `${dateFormat} HH:mm:ss`,
        currency: `${currency}`,
        unit: `${unit}`,
      };
    }
    default:
      return state;
  }
};
